export const SET_MOBILE_VIEW = 'SET_MOBILE_VIEW';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const SET_EMAIL_ID = 'SET_EMAIL_ID';
export const SET_ENLIGHTEN_MANAGER_TOKEN = 'SET_ENLIGHTEN_MANAGER_TOKEN';
export const GET_ACCOUNT_DETAIL_REQUEST = 'GET_ACCOUNT_DETAIL_REQUEST';
export const GET_ACCOUNT_DETAIL_SUCCESS = 'GET_ACCOUNT_DETAIL_SUCCESS';
export const GET_ACCOUNT_DETAIL_FAILURE = 'GET_ACCOUNT_DETAIL_FAILURE';
